// Contact.tsx
import React from "react";
import { Box, Anchor, Group, Title } from "@mantine/core";
import {
  IconBrandFacebook,
  IconBrandX,
  IconBrandLinkedin,
} from "@tabler/icons-react";
import { useDarkModeColors } from "@/hooks/helperHooks/useDarkModeColors";
import { Text } from "@/components/Generics/Text";

const Contact: React.FC = () => {
  const { getColor } = useDarkModeColors();
  return (
    <Box style={{ width: "50vw", margin: "auto", padding: "20px" }}>
      <Title
        order={1}
        size="xl"
        style={{ margin: "20px 0", color: getColor("title") }}
      >
        Contact
      </Title>
      <Group align="flex-start" style={{ marginBottom: "40px" }}>
        <Box>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2708.332983517764!2d-1.550404984381864!3d47.24919167916258!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe451486d739ea452!2sD-ICE+ENGINEERING!5e0!3m2!1sfr!2sus!4v1453712981855"
            width="600"
            height="400"
            style={{ border: "0" }}
            loading="lazy"
          />
        </Box>
        <Box style={{ flex: 1 }}>
          <Title order={2} size="lg" style={{ color: getColor("title") }}>
            D-ICE Engineering Nantes – Headquarters
          </Title>
          <Text size="small">1 rue de la Noë</Text>
          <Text size="small">CS 42103</Text>
          <Text size="small">44321 NANTES</Text>
          <Text size="small">FRANCE</Text>
          <Text size="small">Email: contact@dice-engineering.com</Text>
          <Text size="small">Phone: +33 2 40 37 53 25</Text>
          <Group mt="sm">
            <Anchor
              href="https://www.facebook.com/D.ICE.Engineering"
              target="_blank"
            >
              <IconBrandFacebook size={24} color={getColor("icon")} />
            </Anchor>
            <Anchor href="https://x.com/D_ICE_eng" target="_blank">
              <IconBrandX size={24} color={getColor("icon")} />
            </Anchor>
            <Anchor
              href="https://www.linkedin.com/company/d-ice-engineering/"
              target="_blank"
            >
              <IconBrandLinkedin size={24} color={getColor("icon")} />
            </Anchor>
          </Group>
        </Box>
      </Group>
    </Box>
  );
};

export default Contact;
